module.exports = __webpack_public_path__ + "static/img/re_email.53df9401.png";